"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_class_component_1 = require("vue-class-component");
exports.Meta = vue_class_component_1.createDecorator((options, key) => {
    if (!options.methods)
        return;
    options['metaInfo'] = options.methods[key];
});
